import api from '../../config/api';
import request from '../../lib/request';
import { FileConvertImageVO } from './models/file-convert-image-vo';
export interface ApiGetApiFileConvertResultFileIdParams {
  /** fileId */
  fileId: string;
}
/**
 * 获取文件转换结果
 * @see https://gateway.devp.eastedu.ltd/swagger-ui/index.html?urls.primaryName=assignment-file-convert-service%20(swagger%203.0.3)#/%E6%96%87%E4%BB%B6%E8%BD%AC%E6%8D%A2%E6%8E%A5%E5%8F%A3-2.0/listFileConvertResultUsingGET
 */
export async function apiGetApiFileConvertResultFileId(
  params: ApiGetApiFileConvertResultFileIdParams,
): Promise<FileConvertImageVO[]> {
  const { fileId } = params;
  return request(`/assignment-file-convert-service/api/file/${fileId}/convert-result?version=2.0`, {
    baseURL: api.gateway,
    method: 'GET',
    ignoreLoading: true,
    noUserId: true,
    noLeagueId: true,
  } as any).then((res) => res.data);
}
